import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Showcase from "@/components/Showcase";
import Process from "@/components/Process";
import FoundingLocations from "@/components/FoundingLocations";
import Founder from "@/components/Founder";
import NowServing from "@/components/NowServing";
import SurveyChecklist from "@/components/SurveyChecklist";
import QuoteForm from "@/components/QuoteForm";
import Footer from "@/components/Footer";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(err) {
    console.error(err);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-[#FBF7EF] text-[#16120E] flex items-center justify-center font-sans">
          Something went wrong — please refresh the page.
        </div>
      );
    }
    return this.props.children;
  }
}

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <div className="grain bg-[#FBF7EF] text-[#16120E] font-sans overflow-x-clip">
          <Nav />
          <main>
            <Hero />
            <Marquee />
            <Services />
            <Showcase />
            <Process />
            <SurveyChecklist />
            <FoundingLocations />
            <Founder />
            <NowServing />
            <QuoteForm />
          </main>
          <Footer />
        </div>
        <Toaster position="bottom-right" theme="dark" richColors />
      </BrowserRouter>
    </ErrorBoundary>
  );
}
